// REACT_APP_VERSION is written into .env.local by src/write-env.js: <pkg>.<build id> on the
// pipeline, <pkg>-local otherwise, so the footer (and telemetry) show what the bundle was
// built from.
export const APP_NAME = 'Distribution';
export const APP_VERSION = process.env.REACT_APP_VERSION || '';
